import { render, staticRenderFns } from "./imageSetting.vue?vue&type=template&id=3b3d6e05&scoped=true&"
import script from "./imageSetting.vue?vue&type=script&lang=js&"
export * from "./imageSetting.vue?vue&type=script&lang=js&"
import style0 from "./imageSetting.vue?vue&type=style&index=0&id=3b3d6e05&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3d6e05",
  null
  
)

export default component.exports